import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard } from '@shapeable/ui';
// import { SiteHeaderLayout } from '../entities/site-header-layout';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    /* override title styles via BEM here to affect spacing */ 
    .shp--page-layout-standard__title {
      max-width: 700px;
      margin-bottom: ${theme.UNIT(6)}; 
      font-size: ${40/15}em;
      font-family: ${theme.FONT('sans')};
    }
  `,
  landscape: css`
    .shp--page-layout-standard__title {
      font-size: ${60/15}em;
      margin-bottom: ${theme.UNIT(8)}; 
    }
  `,
  desktop: css`
  .shp--page-layout-standard__title {
  margin-bottom: ${theme.UNIT(10)}; 
    font-size: ${65/15}em;
  }
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  const { titleRich, subtitleRich } = entity;
  const hasTitles = !!titleRich.text || !!subtitleRich.text;

  return (
    <My.Layout 
      className={className}
      entity={entity}
      slices={slices}
      headerProps={{ aspectRatio: 
        { base: 4 / 3, desktop: 21 / 9 }, 
        showOverlayGradient: true, 
        variant: 'overlay', 
        fadeColor: '#0000000', 
        // backgroundColor: '#0000000',
        useBackgroundColor: true }} 
    />
  )
};
